export default function Home(){
    return (
        <h1>Click on Home to check Stocks</h1>
    )
}